import { styled } from '@mui/material/styles';
import { TableRow } from '@mui/material';

const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'hover',
})(({ theme, hover }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#3A4152',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#2C313D',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  ...(hover && {
    '&:hover': {
      backgroundColor: '#4A5262',
    },
  }),
}));

export const CustomTableRow = (props) => {
  return (
    <StyledTableRow key={props.index} hover={props.hover}>
      {props.children}
    </StyledTableRow>
  );
};
